<template>
<div>
    <div class="w-700px mg-auto">
        <p class="bold dp-inblock h-30px font-23 mt-20">{{programName}} 수강자 등록하기</p>
        <p class="font-13 pt-20">
            <span class="bold font-16 dp-block">과목 및 과정 선택</span>
        </p>

        <div class="mt-20">
            <h3 class="font-14 bold">{{className}}</h3>
            <table class="admin-table-col mt-10">
                <colgroup>
                    <col width="50px">
                    <col width="80px">
                    <col width="*">
                    <col width="100px">
                    <col width="80px">
                    <col width="80px">
                    <col width="80px">
                    <col width="80px">
                </colgroup>
                <thead>
                    <tr>
                        <th>No</th>
                        <th>언어</th>
                        <th>과정 명</th>
                        <th>스케줄</th>
                        <th>교육비</th>
                        <th>신청자</th>
                        <th>대기인원</th>
                        <th>수강신청</th>
                    </tr>
                </thead>
                <tbody class="txt-center">
                    <tr v-for="(item, index) of classList" :key="index" :value="item">
                        <td>{{listLength - index}}</td>
                        <td>{{item.language}}</td>
                        <td>{{item.subject_name}}</td>
                        <td>{{item.subject_start_time}} ~ {{item.subject_end_time}}</td>
                        <td>{{item.edu_price}}원</td>
                        <td>
                            <span v-if="item.fa_type === 'N'">
                                제한없음
                            </span>
                            <span v-else>
                                <span class="bold">{{item.applicant_num}}</span>/{{item.fa_num}}
                            </span>
                        </td>
                        <td>
                            <span v-if="item.fa_type === 'N'">
                                제한없음
                            </span>
                            <span v-else>
                                <span class="bold">{{item.current_waiting_num}}</span>/{{item.waiting_num}}
                            </span>
                        </td>
                        <td class="break-all">
                            <span v-if="item.fa_type === 'N'" class="pointer txt-blue" @click="openWindowPopup(item.subject_idx)">수강신청</span>
                            <span v-else-if="item.applicant_num + item.current_waiting_num < item.fa_num + item.waiting_num" class="pointer txt-blue" @click="openWindowPopup(item.subject_idx)">수강신청</span>
                            <span v-else>신청불가</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <load-modal v-if="isLoadModalOpened" :parentIdx="parentIdx" @applyProgram="applyProgram" @close="closeModal"></load-modal>
</div>
</template>

<script>
import LoadModal from '@/components/reg/enroll/loadModal.vue'
import {
    GetUrlParams
} from '@/utils/common.js'
export default {
    components: {
        LoadModal,
    },
    data: () => ({
        programIdx: '', // 프로그램 고유 idx
        programName: '',

        classList: [], // 과목 리스트
        className: '', // 과목명
        listLength: 0, // 과정 개수

        parentIdx: '',
        isLoadModalOpened: false, // 프로그램 선택 모달 (불러오기 시)
    }),

    mounted() {
        if (sessionStorage.getItem('programName')) {
            this.programName = sessionStorage.getItem('programName')
        }

        var oParams = GetUrlParams()
        if (typeof oParams.pageIdx === 'undefined') {
            alert('해당 페이지는 주소창으로의 진입이 불가능합니다.')
            window.close()
        }

        this.pageIdx = oParams.pageIdx
        this.parentIdx = this.pageIdx

        this.isLoadModalOpened = true
    },

    methods: {
        // 수강자 등록 팝업 열기
        openWindowPopup(subjectIdx) {
            let routeData = this.$router.resolve({
                name: 'list-applyList-add',
                query: {
                    subjectIdx: subjectIdx,
                    programIdx: this.programIdx
                }
            });
            var win = window.open(routeData.href, 'window팝업2', 'width=450, height=600, top:100, left:100, menubar=no, status=no, toolbar=no')
            var me = this
            var interval = window.setInterval(function () {
                try {
                    console.log(win)
                    if (win == null || win.closed) {
                        me.applyProgram(me.programIdx)
                        window.clearInterval(interval);
                        closeCallback(win);
                    }
                } catch (e) {}
            }, 1000);
        },

        applyProgram(idx) {
            console.log('api 내부 반응')
            this.programIdx = idx
            var params = {
                programIdx: idx
            }

            this.axios.get(this.axios.root + this.axios.port + '/admin/user-list', {
                params: params
            }).then(res => {
                console.log('res', res)
                if (res.data.err === 0) {
                    this.classList = res.data.classList
                    this.listLength = this.classList.length
                    this.className = this.classList[0].program_name
                    this.isLoadModalOpened = false
                } else {
                    alert(res.data.result)
                }
            })

            // var programIdx = idx
            // var params = {
            //     programIdx: programIdx
            // }
            // this.axios.get(this.axios.root + this.axios.port + `/program/${programIdx}`, params)
            //     .then(res => {
            //         console.log('res', res)
            //         this.isLoadModalOpened = false
            //     }).catch(err => {
            //         console.log(err)
            //         alert(err)
            //     })
        },

        // 과정항목 관리 모달 닫기
        closeModal() {
            if (this.isLoadModalOpened) {
                this.isLoadModalOpened = false
            }
        },
    }
}
</script>
